module.exports = __webpack_public_path__ + "static/img/bottom-corner.e9828daa.svg";